<template>
    <position-timeline-base :customer-view="false"/>
</template>

<script>
import PositionTimelineBase from '@/components/timeline/position-timeline-base';

export default {
    name: 'workspace-timeline-list-page',
    components: {
        PositionTimelineBase,
    },
    metaInfo() {
        return {
            title: this.$t('Timeline'),
        };
    },
};
</script>
